<template>
<div class="flex justify-center">
  <div class="shadow-lg my-4 p-6 rounded-lg w-full md:w-2/3 md:mx-6">
    <div class="text-center text-xl font-medium border-b-2 rounded-sm
                 border-orange-academy-300 pb-1">
       {{$t('student.data')}} </div>

    <div class="mr-4 mt-5 text-left">
      {{$t('student.age')}} {{student.age}}
    </div>
    <div class="mr-4 mt-4 text-left flex">
      <div class="mr-2"> {{$t('student.residence')}} </div>
      <div>
        {{ student.address}},
      {{student.city}} - {{student.postcode}} <br> {{ student.country }}
      </div>

    </div>

  </div>
</div>
</template>

<script>
export default {
  props: {
    student: {},
  },
};
</script>
